import {
  TransactionDetailReportItem,
  TransactionStatItem,
} from "features/generals/domain/entities/transactionReports/TransactionDetailReportResponseEntity";
import { GeneralRangeType, GeneralRowType } from "../interfaces/IGenerals";
import { GeneralPeriodLabelMappers } from "./GeneralPeriodLabelMappers";

export class GeneralRowDataMappers {
  private constructor() {}

  static buildRowData = (
    items: TransactionDetailReportItem[],
    periodLabels: string[],
    range: GeneralRangeType,
    valueField: "quantity" | "revenue"
  ): GeneralRowType[] =>
    items.map((item, index) => {
      const statMap = (item.stat || []).reduce<Record<string, number>>(
        (acc, stat: TransactionStatItem) => {
          const key = GeneralPeriodLabelMappers.formatPeriodLabel(
            String(stat.time),
            range
          );
          acc[key] = Number(stat[valueField] || 0);
          return acc;
        },
        {}
      );
      const totals = (item.stat || []).reduce(
        (acc, stat) => ({
          revenue: acc.revenue + Number(stat.revenue || 0),
          transactions: acc.transactions + Number(stat.quantity || 0),
        }),
        { revenue: 0, transactions: 0 }
      );

      return {
        key: index.toString(),
        name: item.name || item.service || `Item ${index + 1}`,
        service: item.service || "",
        carrier: item.carrier || "",
        ...periodLabels.reduce<Record<string, number>>((acc, label) => {
          acc[label] = statMap[label] || 0;
          return acc;
        }, {}),
        totalRevenue: totals.revenue,
        totalTransactions: totals.transactions,
      };
    });
}
